module.exports = __webpack_public_path__ + "static/img/wing_590.f2c8a5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_590.jpg
// module id = z4CN
// module chunks = 0